import React, { useEffect, useState } from "react";
import Styles from "./ManagerAssets.module.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Table from "../../Layout/Table/Table";
import CustomPagination from "../../Layout/Pagination/ui/Pagination";
import arrowUp from "../../images/arrowUp.svg";
import arrowDown from "../../images/arrowDown.svg";
import Navigation from "../../Layout/Navigation/Navigation";
import { CircularProgress } from "@mui/material";

const ManagerAssets = () => {
  const navigate = useNavigate();
  const { filed_central_index_key } = useParams();
  const [loading, setLoading] = useState(false);
  const [filingsList, setFilingsList] = useState([]);
  const [stocksList, setStocksList] = useState([]);
  const [sortType, setSortType] = useState("DESC");
  const [sortField, setSortField] = useState("filed_as_of_date");
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [page, setPage] = useState(0);
  const [name, setName] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  useEffect(() => {
    const fetchAssets = async () => {
      setLoading(true);
      try {
        const body = {
          filed_central_index_key: filed_central_index_key,
          sortType: sortType,
          sortField: sortField,
          size: rowsPerPage,
          offset: rowsPerPage * page,
        };
        const filings = await axios.post("/api/company/central-index", body);
        setFilingsList(filings.data);
        setCity(filings.data?.results[0]?.filed_city);
        setState(filings.data?.results[0]?.filed_state);
        setName(filings.data?.results[0]?.filed_company_conformed_name);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchAssets();
  }, [filed_central_index_key, rowsPerPage, page, sortField, sortType]);

  useEffect(() => {
    const fetchStocks = async () => {
      setLoading(true);
      try {
        const body = {
          filed_central_index_key: filed_central_index_key,
        };
        const stocks = await axios.post("/api/company/stocks-list", body);
        setStocksList(stocks.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchStocks();
  }, [filed_central_index_key]);

  const formatDate = (string) => {
    if (string.length !== 8) return;
    const year = string.slice(0, 4);
    const month = string.slice(4, 6);
    const day = string.slice(6, 8);
    const stringDate = `${month}/${day}/${year}`;
    return stringDate;
  };

  const columns = [
    {
      accessorKey: "filed_company_conformed_name",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_company_conformed_name");
          }}
          className={Styles.Header}
        >
          Filed Company Name
          {sortField === "filed_company_conformed_name" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => (
        <div
          className={Styles.NameCell}
          onClick={() => {
            navigate(
              `/overview/${row.original.filed_central_index_key}/${row.original.accession_number}`
            );
          }}
          style={{
            textDecoration: "underline",
          }}
        >
          {row.original.filed_company_conformed_name}
        </div>
      ),
    },
    {
      accessorKey: "accession_number",
      header: () => <div>Accession Number</div>,
    },

    {
      accessorKey: "filed_state",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_state");
          }}
          className={Styles.Header}
        >
          State
          {sortField === "filed_state" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => <div>{row.original.filed_state}</div>,
    },
    {
      accessorKey: "filed_city",
      header: () => (
        <div
          onClick={() => {
            setSortType((prev) => (prev === "ASC" ? "DESC" : "ASC"));
            setSortField("filed_city");
          }}
          className={Styles.Header}
        >
          State
          {sortField === "filed_city" ? (
            sortType === "ASC" ? (
              <img src={arrowUp} alt="up" width={15} height={15} />
            ) : (
              <img src={arrowDown} alt="down" width={15} height={15} />
            )
          ) : null}
        </div>
      ),
      cell: ({ row }) => <div>{row.original.filed_city}</div>,
    },
    {
      accessorKey: "form_type",
      header: () => <div>Form Type</div>,
      cell: ({ row }) => <div>{row.original.form_type}</div>,
    },
    {
      accessorKey: "filed_as_of_date",
      header: () => <div>Filed Date</div>,
      cell: ({ row }) => {
        return <div>{formatDate(row.original.filed_as_of_date)}</div>;
      },
    },
  ];

  return loading ? (
    <div className={Styles.Loader}>
      <CircularProgress />
    </div>
  ) : (
    <div className={Styles.App}>
      <Navigation />
      <div className={Styles.Hero}>
        <div className={Styles.LeftHero}>
          <h2>{name}</h2>
          <div className={Styles.LeftHeroDetailsWrapper}>
            <div className={Styles.LeftHeroDetails}>
              <p>City:</p>
              <p>{city}</p>
            </div>
            <div className={Styles.LeftHeroDetails}>
              <p>State:</p>
              <p>{state}</p>
            </div>
            <div className={Styles.LeftHeroDetails}>
              <p>N. of Filings:</p>
              <p>{filingsList?.total}</p>
            </div>
            <div className={Styles.LeftHeroDetails}>
              <p>Latest filed date:</p>
              <p>
                {filingsList?.results &&
                  formatDate(filingsList?.results[0]?.filed_as_of_date)}
              </p>
            </div>
          </div>
        </div>
        <div className={Styles.LeftHero}>
          <div className={Styles.LeftHeroDetailsWrapper}>
            <div className={Styles.PositionContent}>
              <div className={Styles.PositionContentTitle}>
                <h5>Recent Subject Company Names</h5>
              </div>
              {stocksList?.map((item, i) => {
                return (
                  <div className={Styles.PercentageWrapper} key={i}>
                    <div className={Styles.PercentageTitle}>
                      <h5>{item.subject_company_conformed_name}</h5>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className={Styles.TableWrapper}>
        <div>
          <h5>Filings</h5>
          <Table
            data={filingsList?.results ? filingsList.results : []}
            columns={columns}
          />
          <CustomPagination
            count={filingsList?.total}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(newPage) => setPage(newPage)}
            onRowsPerPageChange={(newRowsPerPage) => {
              setRowsPerPage(newRowsPerPage);
              setPage(0);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ManagerAssets;
